import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import '../../TargetReport/TableContent/index.css';
import { TimeCardRegister } from '../../../TimeCard/register';
import { Dialog } from '@material-ui/core';
import * as S from './styles';
import styled from 'styled-components';

function TableContent({ tableData, totais, permiteEdicao, colaboradorId, setReloadData }) {
  const [modalOpen, setModalOpen] = useState(false);
  const [timeCardModal, setTimeCardModal] = useState({});

  const handleCloseModal = () => {
    setTimeCardModal({});
    setReloadData(modalOpen);
    setModalOpen(false);
  };

  const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#F2F1F1',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const dataTable = tableData?.map(function (item, index) {
    const handleOpenModal = (cartao) => {
      if (permiteEdicao) {
        cartao.colaboradorId = colaboradorId;
        setTimeCardModal(cartao);
        setModalOpen(true);
      }
    };

    return (
      <>
        <StyledTableRow
          key={item.index}
          onClick={() => {
            handleOpenModal(item);
          }}
          style={permiteEdicao ? { cursor: 'pointer' } : {}}
        >
          <TableCell align="left">
            <span
              style={
                item.diaDaSemana === 'SÁBADO' || item.diaDaSemana === 'DOMINGO'
                  ? { color: 'red' }
                  : {}
              }
            >
              {item.diaDoMes}
            </span>
          </TableCell>
          <TableCell align="center">{item.cargaHoraria}</TableCell>
          <TableCell align="center">{item.ponto1}</TableCell>
          <TableCell align="center">{item.ponto2}</TableCell>
          <TableCell align="center">{item.ponto3}</TableCell>
          <TableCell align="center">{item.ponto4}</TableCell>
          <TableCell align="center">{item.horasTrabalhadas}</TableCell>
          <TableCell align="center">
            <span style={item.sobraFalta.includes('-') ? { color: 'red' } : {}}>
              {item.sobraFalta}
            </span>
          </TableCell>
          <TableCell align="left">{item.motivo}</TableCell>
        </StyledTableRow>
      </>
    );
  });

  return (
    <>
      {tableData?.length > 0 ? (
        <>
          <div
            className="report-tables"
            style={{
              margin: '0px 45px 0px 50px',
              zIndex: '0',
              position: 'relative',
              justifyContent: 'start',
              flexWrap: 'wrap',
              display: tableData ? 'flex' : 'none',
              overflowX: 'auto',
            }}
          >
            <Table
              style={{
                backgroundColor: 'white',
              }}
            >
              <TableHead style={{ backgroundColor: '#232C63' }}>
                <TableRow>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '260px' }}
                    align="left"
                  >
                    Dia do Mês
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Carga Horária
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Entrada
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Saída Almoço
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Retorno Almoço
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Saída
                  </TableCell>

                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Horas Trabalhadas
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '120px' }}
                    align="center"
                  >
                    Sobra/Falta
                  </TableCell>
                  <TableCell
                    style={{ color: 'white', fontWeight: 'bold', width: '100px' }}
                    align="center"
                  >
                    Motivo
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataTable}

                <TableRow>
                  <TableCell align="left"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>
                  <TableCell align="center"></TableCell>

                  <TableCell align="center" style={{ backgroundColor: '#C4C4C4' }}>
                    {totais?.horasTrabalhadas}
                  </TableCell>
                  <TableCell align="center" style={{ backgroundColor: '#C4C4C4' }}>
                    <span style={totais?.sobraFalta.includes('-') ? { color: 'red' } : {}}>
                      {totais?.sobraFalta}
                    </span>
                  </TableCell>
                  <TableCell align="left"></TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <div
              style={{
                backgroundColor: 'white',
                marginBottom: '20px',
                boxShadow:
                  '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                padding: '8px',
              }}
            >
              <span style={{ fontWeight: 'bold', marginBottom: '5px' }}>Motivos:</span>
              <span>
                Feriado, 1 - Ausência Justificada, 2 - Ausência Justificada Com Atestado, 3 -
                Ausência Não Justificada, 4 - Treinamento, 5 - Férias
              </span>
            </div>
          </div>
          <div
            style={{
              marginTop: '20px',
              zIndex: '0',
              position: 'relative',
              justifyContent: 'start',
            }}
          ></div>
        </>
      ) : (
        ''
      )}
      <Dialog
        open={modalOpen}
        onClose={() => {
          handleCloseModal();
        }}
        maxWidth={'100%'}
      >
        <TimeCardRegister
          item={timeCardModal}
          isModal={true}
          modalGoBackFunction={handleCloseModal}
        ></TimeCardRegister>
      </Dialog>
    </>
  );
}

export default TableContent;
